function shiftModal(x){
    const wrapper = $(x).find(`.flex.variant.active`);
    const _hasImage = wrapper.find('.compare-image').length != 0;
    if(_hasImage){
      const _mobile = wrapper.css('display') == 'block';
      if(_mobile){
        if (window.matchMedia('(max-width: 500px)').matches){
          $(".modal-compare-content").css('top' , '85%');
        } else {
          $(".modal-compare-content").css('top' , '70%');
        }
        
      }
    }else{
      $(".modal-compare-content").attr('style', '');
    }
}


function openCompareModal(e) {
    let compareModal = $(e).siblings('.compareModal'); // modal
    compareModal.show();
    shiftModal(compareModal);
}

function closeCompareModal() {
    $('.compareModal').hide(); // modal
}

function compareTableItem(e) {
  let variantId = $(e).data('variation');
  $(e).parents('.body-content').find('.active').removeClass('active');
  $(e).parents('.body-content').find(`.flex.variant.${variantId}`).addClass('active');
  $(e).addClass('active');
  $(e).parents('.body-content').find(`.compare-table.${variantId}`).addClass('active');
  shiftModal($(e).parents('.body-content'));
}
